import React, { Component } from "react";
import "./Header.css";
import { Link, withRouter } from "react-router-dom";
import { greeting } from "../../portfolio.js";
import SeoHeader from "../seoHeader/SeoHeader";
import { LanguageContext, translate } from "../../i18n";
import { ThemeModeContext } from "../../themeMode";

class Header extends Component {
  static contextType = LanguageContext;

  state = {
    activeSection: "home",
  };

  sectionIds = ["home", "experience", "projects", "products", "contact"];

  componentDidMount() {
    window.addEventListener("scroll", this.updateActiveSection, {
      passive: true,
    });
    window.addEventListener("resize", this.updateActiveSection);
    window.requestAnimationFrame(this.scrollToCurrentSection);
    this.updateActiveSection();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname !== this.props.location.pathname ||
      prevProps.location.hash !== this.props.location.hash
    ) {
      window.requestAnimationFrame(this.scrollToCurrentSection);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.updateActiveSection);
    window.removeEventListener("resize", this.updateActiveSection);
  }

  isHomePage = () => {
    const path = this.props.location.pathname;
    return path === "/" || path === "/home";
  };

  scrollToCurrentSection = () => {
    if (!this.isHomePage()) return;

    const sectionId = this.props.location.hash.replace("#", "") || "home";
    const section = document.getElementById(sectionId);

    if (section) {
      section.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
          ? "auto"
          : "smooth",
        block: "start",
      });
    }
  };

  updateActiveSection = () => {
    if (!this.isHomePage()) return;

    const headerOffset = 32;
    let activeSection = "home";

    this.sectionIds.forEach((sectionId) => {
      const section = document.getElementById(sectionId);
      if (section && section.getBoundingClientRect().top <= headerOffset) {
        activeSection = sectionId;
      }
    });

    if (activeSection !== this.state.activeSection) {
      this.setState({ activeSection });
    }
  };

  handleSectionClick = (event) => {
    const menuToggle = document.getElementById("menu-btn");
    if (menuToggle) menuToggle.checked = false;
    if (event.currentTarget.hash === this.props.location.hash) {
      window.requestAnimationFrame(this.scrollToCurrentSection);
    }
  };

  sectionLinkClass = (sectionId) =>
    this.isHomePage() && this.state.activeSection === sectionId
      ? "active-nav-link"
      : "";

  render() {
    const theme = this.props.theme;
    const link = "/home#home";
    const { language, toggleLanguage } = this.context;
    return (
      <ThemeModeContext.Consumer>
        {({ mode, toggleTheme }) => (
          <>
            <SeoHeader />
            <div className="header-shell">
              <header className="header">
                <Link
                  to={link}
                  className="logo"
                  onClick={this.handleSectionClick}
                >
                  <span style={{ color: theme.text }}> &lt;</span>
                  <span className="logo-name" style={{ color: theme.text }}>
                    {greeting.logo_name}
                  </span>
                  <span style={{ color: theme.text }}>/&gt;</span>
                </Link>
                <input
                  className="menu-btn"
                  type="checkbox"
                  id="menu-btn"
                  aria-label={
                    language === "ar" ? "قائمة التنقل" : "Navigation menu"
                  }
                />
                <label className="menu-icon" htmlFor="menu-btn">
                  <span className="navicon"></span>
                </label>
                <ul className="menu">
                  <li>
                    <Link
                      to="/home#home"
                      className={this.sectionLinkClass("home")}
                      onClick={this.handleSectionClick}
                      style={{ color: theme.text }}
                    >
                      {translate("Home")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/home#experience"
                      className={this.sectionLinkClass("experience")}
                      onClick={this.handleSectionClick}
                      style={{ color: theme.text }}
                    >
                      {translate("Experience")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/home#projects"
                      className={this.sectionLinkClass("projects")}
                      onClick={this.handleSectionClick}
                      style={{ color: theme.text }}
                    >
                      {translate("Projects")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/home#products"
                      className={this.sectionLinkClass("products")}
                      onClick={this.handleSectionClick}
                      style={{ color: theme.text }}
                    >
                      {translate("Products")}
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/home#contact"
                      className={this.sectionLinkClass("contact")}
                      onClick={this.handleSectionClick}
                      style={{ color: theme.text }}
                    >
                      {translate("Contact Me")}
                    </Link>
                  </li>
                  <li className="language-menu-item">
                    <button
                      type="button"
                      className="theme-toggle"
                      onClick={toggleTheme}
                      style={{
                        color: theme.imageHighlight,
                        borderColor: theme.imageHighlight,
                        backgroundColor: "transparent",
                      }}
                      aria-label={
                        language === "ar"
                          ? mode === "dark"
                            ? "التبديل إلى الوضع الفاتح"
                            : "التبديل إلى الوضع الداكن"
                          : mode === "dark"
                          ? "Switch to light mode"
                          : "Switch to dark mode"
                      }
                      title={mode === "dark" ? "Light mode" : "Dark mode"}
                    >
                      <span aria-hidden="true">
                        {mode === "dark" ? "☀" : "☾"}
                      </span>
                    </button>
                    <button
                      type="button"
                      className="language-toggle"
                      onClick={toggleLanguage}
                      style={{
                        color: theme.imageHighlight,
                        borderColor: theme.imageHighlight,
                        backgroundColor: "transparent",
                      }}
                      aria-label={
                        language === "ar"
                          ? "Switch language to English"
                          : "تغيير اللغة إلى العربية"
                      }
                    >
                      <span
                        className="iconify language-icon"
                        data-icon="mdi:web"
                        data-inline="false"
                        aria-hidden="true"
                      ></span>
                      {language === "ar" ? "EN" : "عربي"}
                    </button>
                  </li>
                </ul>
              </header>
            </div>
          </>
        )}
      </ThemeModeContext.Consumer>
    );
  }
}
export default withRouter(Header);
